import * as dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { DEFAULT_DATE_FORMAT } from 'data/constants';

export const formatDate = (input, inputFormat, outputFormat) => {
  if (input) {
    const dateFormat = outputFormat || DEFAULT_DATE_FORMAT;
    return dayjs(input, inputFormat).locale('ko').format(dateFormat);
  }

  return '';
}